// 将所有的item设置成响应式
export function addShowHash(arr, target, call) {
    for (let i = 0; i < arr.length; i++) {
        call(target, arr[i].id, true)
        if (arr[i].items) {
            addShowHash (arr[i].items, target, call)
        }
    }
}
// 筛选出符合条件的item
export function filtrateShow(searchParam, menus, level = 0, showParent = true) {
    if (typeof searchParam === 'string') {
        if ((/[a-zA-Z\t]+/g).test(searchParam)) { // 拼音匹配
            searchParam = searchParam.split(/\s+/g).join('')
            let str = ''
            for (let i = 0; i < searchParam.length; i++) {
                str = str + searchParam[i] + '[a-zA-Z]*'
            }
            searchParam = new RegExp(str)
        } else { // 汉字匹配
             searchParam = searchParam.split(/\s+/g)
        }
    }
    let arr = []
    for (let i = 0; i < menus.length; i++) {
        // 当父级是满足搜索条件的，子级为展示
        // 当前条目满足搜索条件，展示并向下传递
        if ((level !== 0 && showParent) || // 当父级是满足搜索条件的，子级为展示
        (searchParam.length && searchParam.every(searchParamitem => menus[i].name.includes(searchParamitem))) || // 当前条目满足搜索条件，展示并向下传递
        // (searchParam.every(searchParamitem => menus[i].pinyin.includes(searchParamitem))) // 拼音搜索
        (searchParam.test && searchParam.test(menus[i].pinyin))
        ) {
            const arrChildren = menus[i].items ? filtrateShow (searchParam, menus[i].items, level + 1, true) : []

            arr = arr.concat(menus[i].id, arrChildren)

        } else {
            // 当前条目不满足条件，但是下级并不一定满足，需要向下传递
            const arrChildren = menus[i].items ? filtrateShow (searchParam, menus[i].items, level + 1, false) : []
            if (arrChildren.length > 0) {
                arr = arr.concat(menus[i].id, arrChildren)
            }
       }
    }
    if (level === 0) {
        const obj = {}
        arr.forEach(id => {
            obj[id] = true
        })
        return obj
    }
    return arr
}

// 检查列表中的key是否重复
export function checkoutKeyRepeat(list, hashKey = {}, hashName = {}) {
    for (let i = 0; i < list.length; i++) {
        if (hashKey[list[i].key]) {
          // throw new Error(list[i].key+' key重复，key需要在列表中唯一')
          console.error(`已存在${list[i].key},key值在menus列表中唯一存在`)
        }
        if (hashName[list[i].name]) {
            console.error(`已存在${list[i].name},name值在menus列表中唯一存在`)
            // throw new Error(list[i].name+' name重复，name需要在列表中唯一')
          }
        hashKey[list[i].key] = true
        hashKey[list[i].name] = true
        if (list[i].children) {
            checkoutKeyRepeat (list[i].children, hashKey, hashName)
        }
    }
}

// 筛选出有子级的item
export function getLevel0Name(list, hasName = {}) {
    for (let i = 0; i < list.length; i++) {
       if (list[i].items) {
        hasName[list[i].id] = list[i].name
        getLevel0Name (list[i].items, hasName)
       }
    }
    return hasName
}

// 筛选出已选项目的父级祖父级...
export function findelder(arr, target) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].path === target) {
            return [ arr[i].id ]
        }
        if (arr[i].items) {
            for (let j = 0; j < arr[i].items.length; j++) {
                const result = findelder (arr[i].items, target)
                if (result) {
                    result.push(arr[i].id)
                    return result
                }
            }
        }
    }
}

// array=>hash 获取当前节点之前的节点
export function toHashOlder(arr, hash = {}, node = []) {
    for (let i = 0; i < arr.length; i++) {
         hash[arr[i].path] = [...node, arr[i]]
        if (arr[i].items && arr[i].items.length > 0) {
            toHashOlder(arr[i].items, hash, hash[arr[i].path])
        }
    }
    return hash
}
// 拼接路由
export function jointRouterDetail(router, arr = []) {
    let obj;
    for (let i = 0, len = router.length;i < len;i++) {
        const item = router[i]
        obj = {
            name: item.name,
            path: item.path
        }
        if (item.items && item.items.length > 0) {
            const _arr = jointRouterDetail(item.items)
            obj.items = _arr
        }
        arr.push(obj)
    }
    return arr
}
export const standardMenus = function(data) {
    const items_arr = []
    let red_dot_token_arr = []
    for (let i = 0;i < data.length;i++) {
        const item = data[i]
        let node = {}
        let red_dot_token_arr_child = []
        node = {
            id: item.id,
            parent_id: item.parent_id,
            name: item.name,
            pinyin: item.pinyin,
            icon: item.icon,
            red_dot_token: item.red_dot_token,
            path: item.path,
            route_type:item.route_type,
        }
        if (node.red_dot_token) {
            red_dot_token_arr.push(node.red_dot_token)
        }
        switch (item.route_type) {
            case 'powerbi':
                node.pb_report_id = item.pb_report_id
                node.pb_workspace_id = item.pb_workspace_id
                node.path = `/dashBoard/routerDetail/${node.id}`
                break;
            case 'iframe':
            case 'tableau':
                node.iframe_path = item.path
                node.url = node.path
                node.path = `/iframeRouter/${node.id}`
                break
            case 'button':
                node.auth_key = item.auth_key
                node.path = item.path
                break
            default:
                break;
        }
        if (item.items && item.items.length) {
            const [items, _red_dot_token_arr_child] = standardMenus(item.items)
            red_dot_token_arr_child = _red_dot_token_arr_child || []
            node.items = items
        }
        if (!node.path) { // TODO
            node.red_dot_token = red_dot_token_arr_child.length ? red_dot_token_arr_child : undefined
        }
        red_dot_token_arr = red_dot_token_arr.concat(red_dot_token_arr_child)
        items_arr.push(node)
    }
    return [ items_arr, red_dot_token_arr ]
}

// 鉴权hash
export const authorityFun = function(data) {
    return data.reduce(function _reducer(total, item) {
        switch (item.route_type) {
            case 'button':
                total[item.auth_key] = true
                break
            default:
                break;
        }
        if (item.path) {
            total[item.path] = true
        }
        if (item.items && item.items.length) {
            item.items.reduce(_reducer, total)
        }
        return total
    }, {})
}

// id=>item
export const idToItemDetail = function(data) {
    return data.reduce(function _reducer(total, item) {
        total[item.id] = item
        if (item.items && item.items.length) {
            item.items.reduce(_reducer, total)
        }
        return total
    }, {})
}

// path => item
export const pathToItemDetail = function(data) {
    return data.reduce(function _reducer(total, item) {
        total[item.path] = item
        if (item.items && item.items.length) {
            item.items.reduce(_reducer, total)
        }
        return total
    }, {})
}
// 筛选出在左侧导航栏和顶部导航栏的标签
export const displayMenus = function(data) {
    const arr = []
    for (let i = 0, len = data.length;i < len;i++) {
        const { items = [], route_type = '', path, ...other } = data[i]
        if (route_type === 'button') {
            continue
        }
        if (path) {
            arr.push({
                route_type,
                path,
                ...other
            })
            continue
        }
        const node = {
            items,
            route_type,
            path,
            ...other
        }
        if (items && items.length) {
            node.items = displayMenus(items)
        }
        arr.push(node)
    }
    return arr
}
